export default __webpack_public_path__ + "static/media/fad-slider-round-1.29c97b21.svg";